import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaProfile = React.lazy(() =>
    import('../NebulaProfile')
);
const nebulaProfileRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_PROFILE_PAGE,
        element: <NebulaProfile />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaProfileRoutesRegistry;
